var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/* eslint-disable lines-around-comment */
/* eslint-disable require-jsdoc */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { makeStyles } from 'tss-react/mui';
// @ts-ignore
import { authService } from '../../../../../service';
// @ts-ignore
import { useSocket } from "../../../socket-io/SocketContext";
// @ts-ignore
import { getLocalParticipant, PARTICIPANT_ROLE } from "../../../base/participants";
const useStyles = makeStyles()(() => {
    return {
        modal: {
            position: 'absolute',
            flex: 1,
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.5)',
            backdropFilter: 'blur(4px)'
        },
        modalBody: {
            padding: 24,
            backgroundColor: '#ffffff',
            borderRadius: 12
        },
        title: {
            color: '#979797',
            fontSize: 14,
            fontWeight: 500
        },
        footer: {
            display: 'flex',
            alignItems: 'center',
            marginTop: 16,
            gap: 8
        },
        buttonAccept: {
            backgroundColor: '#1aa258',
            padding: '8px 16px',
            borderRadius: 8,
            flex: 1,
            textAlign: 'center',
            fontWeight: 600
        },
        buttonDecline: {
            backgroundColor: '#ff0000',
            padding: '8px 16px',
            borderRadius: 8,
            flex: 1,
            textAlign: 'center',
            fontWeight: 600
        }
    };
});
function formatPhoneNumber(phoneNumberString) {
    const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
    const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        const intlCode = match[1] ? '+1 ' : '';
        return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
    }
}
const ModalCallIncoming = () => {
    var _a;
    const [callIncoming, setCallIncomingCall] = useState();
    const { classes } = useStyles();
    const { sendMessage, lastMessage } = useSocket(); // get methods from context
    const loading = useRef(false);
    // @ts-ignore
    const room = (_a = APP.store.getState()['features/base/dialog'].componentProps) === null || _a === void 0 ? void 0 : _a.roomId;
    // @ts-ignore
    const isModerator = getLocalParticipant(APP.store.getState()).role === PARTICIPANT_ROLE.MODERATOR;
    // @ts-ignore
    const roomCode = APP.store.getState()['features/base/conference'].room;
    // @ts-ignore
    const refPortal = useRef(null);
    useEffect(() => {
        if (!sendMessage)
            return;
        sendMessage({ type: 'join-room', room: room || roomCode });
    }, [sendMessage, room, roomCode]);
    useEffect(() => {
        if (!lastMessage || (lastMessage === null || lastMessage === void 0 ? void 0 : lastMessage.type) !== "call")
            return;
        if (!(loading === null || loading === void 0 ? void 0 : loading.current)) {
            setCallIncomingCall(lastMessage);
        }
    }, [lastMessage]);
    useEffect(() => {
        var _a;
        refPortal.current = document.createElement('div');
        (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.appendChild(refPortal.current);
        return () => {
            var _a;
            try {
                if (refPortal.current) {
                    (_a = document.querySelector('body')) === null || _a === void 0 ? void 0 : _a.appendChild(refPortal.current);
                }
                // eslint-disable-next-line no-empty
            }
            catch (_b) { }
        };
    }, []);
    const onAccept = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!callIncoming) {
            return;
        }
        setCallIncomingCall(undefined);
        loading.current = false;
        yield authService.actionCallIncoming(callIncoming, true);
    }), [callIncoming]);
    const onDecline = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!callIncoming) {
            return;
        }
        loading.current = true;
        setCallIncomingCall(undefined);
        yield authService.actionCallIncoming(callIncoming);
        loading.current = false;
    }), [callIncoming]);
    if (!isModerator || !callIncoming || !refPortal.current) {
        return null;
    }
    return (createPortal((React.createElement("div", { className: classes.modal },
        React.createElement("div", { className: classes.modalBody },
            React.createElement("p", { className: classes.title },
                "Incoming Call from ",
                formatPhoneNumber(callIncoming.fromPhone)),
            React.createElement("div", { className: classes.footer },
                React.createElement("div", { className: classes.buttonAccept, onClick: onAccept }, "Accept"),
                React.createElement("div", { className: classes.buttonDecline, onClick: onDecline }, "Decline"))))), refPortal.current));
};
export default ModalCallIncoming;
